module.exports = __webpack_public_path__ + "media/images/components/base/container/gradient-hero-banner-desktop@2x-44da619e577e561ef5378c825b4972b9.jpg";